import { useMemo } from 'react';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { calendar_theme } from '../constants';
import { CalendarTheme, CalendarThemePartial } from '../types';

export const useCalendarTheme = (
  theme: Partial<CalendarThemePartial> = calendar_theme
): CalendarTheme => {
  const {
    theme: {
      calendar: { general, background, color },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      background: { ...background, ...theme.background },
      color: { ...color, ...theme.color },
    }),
    [theme, general, background, color]
  );
};
